import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import FormGroup from '@material-ui/core/FormGroup';
import InlineDatePicker from "../../utils/InlineDatePicker"
const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200
    },
    root: {
        flexGrow: 1,
        paddingLeft: '15px',
        marginBottom: '15px'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px"
    }
});

function DatePicker(props) {
    const { onSubmit, startDate, endDate, handleDateChange } = props;

    return (
        <div>
            <form onSubmit={onSubmit}>
                <FormGroup>
                    <div style={{margin: '0 0 25px'}}>
                        <InlineDatePicker label={'Start Date'} Date={startDate}  handleDateChange={(date) => handleDateChange(date, 'StartDate')} />
                    </div>

                    <div style={{margin: '0 0 25px'}}>
                        <InlineDatePicker label={'End Date'} Date={endDate}  handleDateChange={(date) => handleDateChange(date, 'EndDate')} />

                    </div>
                </FormGroup>
            </form>
        </div>
    );
}

export default withStyles(styles)(DatePicker);



// WEBPACK FOOTER //
// ./src/Regional-Views/Dashboard/MonthPicker.jsx